import moment from "moment";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import { classNames } from "../Reusable/DatePicker/helpers";
import TableActionButton from "../Reusable/TableActionButton";
import NACell from "../Reusable/DataTable/NACell";
import { useState } from "react";
import useDeleteHook from "../../customHooks/useDeleteHook";
import TableDeleteButton from "../Reusable/TableDeleteButton";
import Modal from "../Reusable/Modal";
import ImageCell from "../Reusable/DataTable/ImageCell";
import { AccessControl } from "@careinfo/permission-required";

const AuthorListComponent = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["delete-category"],
    navigateURL: "/blog/category",
  });

  const handleDelete = (id: string) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const handleModalClose = () => {
    setOpenDeleteModal(false);
    setSelectedId("");
  };

  const deleteCategory = async () => {
    const url = `${APIS.BLOG_CATEGORY}${selectedId}/`;
    try {
      await mutateAsync({ url });
      handleModalClose();
    } catch (error) {
      console.error(error);
    }
  };

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: ImageCell,
    },
    {
      header: "Created At",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>
              {moment(getValue()).format("YYYY-MM-DD HH:mm")}
            </p>
          </>
        );
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`flex items-center justify-around`}>
            <AccessControl
              children={
                <p className={tw`uppercase flex items-center justify-center`}>
                  <TableActionButton
                    editPath={`/blog/category/edit/${getValue()}`}
                  />
                </p>
              }
              allowedPermissions={["can_update_categories"]}
            />
            <AccessControl
              children={
                <p className={tw`uppercase w-5 h-5`}>
                  <TableDeleteButton
                    onClick={() => handleDelete(getValue())}
                    disabled={isLoading}
                  />
                </p>
              }
              allowedPermissions={["can_delete_categories"]}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.BLOG_CATEGORY}
        queryKey={"category"}
        columns={defaultColumns}
        addNewPagePath={"/blog/category/create"}
        tableName={"Category"}
      />
      <Modal
        isOpen={openDeleteModal}
        setIsOpen={setOpenDeleteModal}
        title={"Delete Category"}
        onClose={handleModalClose}
        showTitle={false}
      >
        <div className={tw`space-y-3 w-fit`}>
          <h2 className={tw`text-xl font-bold`}>Are you sure?</h2>
          <div className={tw`flex items-center gap-5 justify-end`}>
            <button
              className={tw`bg-gray-200 rounded-lg px-2 py-2 focus:outline-none`}
              onClick={handleModalClose}
            >
              Cancel
            </button>
            <button
              onClick={deleteCategory}
              className={tw`px-2 py-2 rounded-lg bg-red-600  text-white disabled:bg-red-300`}
              disabled={isLoading}
            >
              <p>Delete</p>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AuthorListComponent;
